/**
 * Utilitaires pour la gestion des abonnements
 */

import moment from 'moment';
import 'moment/locale/fr';

/**
 * Vérifie si l'utilisateur a un accès premium (Gold ou Platinum) valide
 * @param {Object} authState - État d'authentification de l'utilisateur
 * @returns {boolean} True si l'utilisateur a un accès premium valide
 */
export const hasPremiumAccess = (authState) => {
  const currentTime = Math.floor(Date.now() / 1000);
  return (authState.level === 'gold' || authState.level === 'platinum') && 
         authState.packageEndDate && 
         currentTime < authState.packageEndDate;
};

/**
 * Vérifie si l'utilisateur a un abonnement actif (Plus, Gold ou Platinum)
 * @param {Object} authState - État d'authentification de l'utilisateur
 * @returns {boolean} True si l'utilisateur a un abonnement actif
 */
export const hasActiveSubscription = (authState) => {
  const currentTime = Math.floor(Date.now() / 1000);
  return (authState.level === 'plus' || authState.level === 'gold' || authState.level === 'platinum') && 
         authState.packageEndDate && 
         currentTime < authState.packageEndDate;
};

/**
 * Vérifie si l'utilisateur a un abonnement Platinum actif
 * @param {Object} authState - État d'authentification de l'utilisateur
 * @returns {boolean} True si l'utilisateur a un abonnement Platinum actif
 */
export const hasPlatinumAccess = (authState) => {
  const currentTime = Math.floor(Date.now() / 1000);
  return authState.level === 'platinum' && 
         authState.packageEndDate && 
         currentTime < authState.packageEndDate;
};

/**
 * Formate le niveau d'abonnement pour l'affichage
 * @param {string} level - Niveau d'abonnement (plus, gold, platinum)
 * @returns {string} Niveau d'abonnement formaté
 */
export const formatSubscriptionLevel = (level) => {
  if (!level) return '';
  const levels = {
    plus: 'Plus',
    gold: 'Gold',
    platinum: 'Platinum'
  };
  return levels[level.toLowerCase()] || level;
};

/**
 * Formate la date d'expiration de l'abonnement
 * @param {number} timestamp - Timestamp Unix de la date d'expiration
 * @returns {string} Date d'expiration formatée
 */
export const formatExpiryDate = (timestamp) => {
  if (!timestamp) return '';
  moment.locale('fr');
  return moment.unix(timestamp).format('DD MMMM YYYY');
};
